module.exports = __webpack_public_path__ + "static/sill-nav-7284358129e86d9562840b222572ed7e.jpeg";